import { cn } from '@/lib/cn';
import type { InstructionStatus } from './types';

// ---------------------------------------------------------------------------
// Status filter pills — matches legacy .tm-pill styling
// ---------------------------------------------------------------------------

interface StatusOption {
  value: InstructionStatus;
  label: string;
}

const STATUS_OPTIONS: StatusOption[] = [
  { value: 'all', label: 'All' },
  { value: 'pending_client_approval', label: 'Pending Client Approval' },
  { value: 'pending', label: 'Pending Review' },
  { value: 'processing', label: 'Processing' },
  { value: 'completed', label: 'Completed' },
  { value: 'held', label: 'On Hold' },
  { value: 'declined', label: 'Declined' },
  { value: 'failed', label: 'Failed' },
];

export interface FilterPillsProps {
  selected: InstructionStatus;
  onChange: (status: InstructionStatus) => void;
}

export function FilterPills({ selected, onChange }: FilterPillsProps) {
  return (
    <div className="flex flex-wrap gap-2" role="tablist" aria-label="Filter by status">
      {STATUS_OPTIONS.map((opt) => (
        <button
          key={opt.value}
          role="tab"
          aria-selected={selected === opt.value}
          onClick={() => onChange(opt.value)}
          className={cn(
            'rounded-[20px] border px-4 py-[7px] text-xs font-medium transition-colors',
            selected === opt.value
              ? 'border-[#6B0F1A] bg-[#6B0F1A] text-white'
              : 'border-[#ddd] bg-white text-[#666] hover:border-[#6B0F1A] hover:text-[#6B0F1A]',
          )}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
